import React, { useState } from "react";
import Qrcode from "../components/Qrcode";
import jsPDF from "jspdf";
import { renderToString } from "react-dom/server";
import html2canvas from "html2canvas";
import GenericPdfDownloader from "../components/GenericPdfDownloader";
import { format } from "date-fns";

const page = {
  /*  pageBreakAfter: "always", */
  fontSize: 10,
  background: "white",
  padding: 10,
};
const Airconqrcode = () => {
  const [qrcodearr, setQrcodearr] = useState([]);
  const [totalQr, setTotalQr] = useState(1);
  const [title, setTitle] = useState("");
  const [airconid, setAirconid] = useState("");

  const generateqrcode = () => {
    if (totalQr > 10) {
      alert('Currently allow to create only 10 Qr codes')
    } else {
      const date = new Date();
      const airconsid =
        "A" +
        (Math.floor(Math.random() * 9999) + 1000).toString() +
        date.getFullYear().toString() +
        date.getMonth().toString() +
        date.getDay().toString() +
        date.getHours().toString() +
        date.getMinutes().toString();


      let i = 0;
      let qrarr = [];
      let urll = "https://letscoolsupport.com/preventivemaintenance/#/airconview?aircon_id="
      for (i = 0; i < totalQr; i++) {
        qrarr.push(airconid != "" ? urll + airconid : urll + airconsid);
      }
      setQrcodearr(qrarr);
      console.log(qrarr);
    }
  };

  return (
    <div>
      <div className="container">
      <div>
          <div className="d-flex  mb-2 ">
            <h1 className="flex-fill">Aircon QR Code</h1><div>{/* <button
              onClick={() => {
                navigate("/clientevent");
              }}
              type="submit"
              className="btn btn-primary"
            >
              <i className="fa fa-plus"></i> Add Client
            </button> */}</div>
          </div>
        </div>
        <div className="card bg-white shadow-sm p-3">
          <div className="row">
            <div className="col-md-5">
              <label htmlFor="qrtitle" className="form-label">
                Title
              </label>
              <input
                type="text"
                className="form-control"
                id="qrtitle"
                placeholder="Title (optional)"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <div className="col-md-3">
              <label htmlFor="aircon_id" className="form-label">
                Aircon ID
              </label>
              <input
                type="text"
                className="form-control"
                id="aircon_id"
                placeholder="aircon id (optional)"
                value={airconid}
                onChange={(e) => setAirconid(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <label htmlFor="nos" className="form-label">
                No.of Qr codes
              </label>
              <input
                type="number"
                className="form-control"
                id="nos"
                placeholder="nos"
                value={totalQr}
                onChange={(e) => setTotalQr(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <button
                onClick={() => generateqrcode()}
                style={{ marginTop: 39 }}
                className="btn btn-primary "
              >
                Generate QR
              </button>
            </div>
          </div>
        </div>
        <div className="mt-2 text-end">
          <GenericPdfDownloader
            downloadFileName="CustomPdf"
            rootElementId="testId"
          />
        </div>
        <div className="">
          <div style={{ width: 595 }} className="page bg-white p-1" id="testId">
            <div className="mb-5 mt-3">
              <h5 className=" text-capitalize text-center">
                {title} QRCode {airconid != "" ? "-" + airconid : ""}
              </h5>
              <p style={{ fontSize: 10 }} className="text-center">Created - {format(new Date(), "PPpp")}</p>
            </div>
            <div >
              {qrcodearr.length > 0 ? (
                <div>
                  <div className="d-flex flex-wrap ">
                    {qrcodearr.map((qrcodearr, index) => (
                      <div style={{ width: 250, height: 100, padding: 5 }} className=" bg-white" key={index}>
                        <Qrcode aircon_id={qrcodearr} />
                      </div>

                    ))}
                  </div>
                </div>
              ) : (
                <div className="text-center p-3">0 record found</div>
              )}
            </div>
            <p className="m-4 text-center">*This is auto generated qrcode</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Airconqrcode;
